import React from 'react';
import { PopconfirmProps } from 'antd';

import {
  StyledAntdPopconfirm,
} from './style';

const CVPopover = (props: PopconfirmProps): JSX.Element => (
  <StyledAntdPopconfirm {...props} />
);

export default CVPopover;
